import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import Auth0ProviderWithHistory from './auth/auth0-provider-with-history';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { datadogRum } from '@datadog/browser-rum';

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API,
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['Prod', 'Staging', 'Dogfood'],
  releaseStage: process.env.REACT_APP_KIT_ENV,
});

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_KEY,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'lab-automation',
  env: process.env.REACT_APP_KIT_ENV,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  trackUserInteractions: false,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <div className="bg-kit-light-1 px-4">
      <Router>
        <Auth0ProviderWithHistory>
          <App />
        </Auth0ProviderWithHistory>
      </Router>
    </div>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
